import { type JSXElement } from 'solid-js'
import { createStore } from 'solid-js/store'

const [dialog, setDialog] = createStore<{
  isOpen: boolean
  isLoading: boolean
  title: string
  description: string | (() => JSXElement)
  descriptionClass?: string
  primaryButtonText: string
  secondaryButtonText?: string
  primaryAction?: () => void
  asyncPrimaryAction?: () => Promise<void>
  secondaryAction?: () => void
}>({
  isOpen: false,
  isLoading: false,
  title: '',
  description: '',
  primaryButtonText: '',
})

export { dialog }

export const closeDialog = () => {
  setDialog({ isOpen: false, isLoading: false })
}

export const setDialogLoading = (isLoading: boolean) => {
  setDialog('isLoading', isLoading)
}

export const showDialog = (payload: {
  title: string
  description: string | (() => JSXElement)
  descriptionClass?: string
  primaryButtonText: string
  secondaryButtonText?: string
  primaryAction?: () => void
  asyncPrimaryAction?: () => Promise<void>
  secondaryAction?: () => void
}) => {
  setDialog({
    isOpen: true,
    isLoading: false,
    descriptionClass: undefined,
    secondaryButtonText: undefined,
    primaryAction: undefined,
    asyncPrimaryAction: undefined,
    secondaryAction: undefined,
    ...payload,
  })
}
